
export default class DeviceAttribute {

    public name: string = "";

    public value: string = "";
    
    public displayValue : string | null = null;
}